import { CircleAlert, CircleCheck, Info, TriangleAlert, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Icons, Slide, ToastContainer } from 'react-toastify';

// Toaster — el único contenedor de avisos (react-toastify) de la app. Lo montan los layouts
// (principal, login y torre de control); antes cada uno copiaba la misma configuración.
// El aspecto vive en `scss/_toasts.scss`: tarjeta con tokens (bg/fg/border/status-*), así
// que funciona en light/dark, en los temas de marca y en modo daltónico sin código extra.
//
// Sin pausa al pasar el mouse: el aviso se quedaba congelado mientras el cursor estuviera
// encima (p. ej. justo después de "Copiar resumen"). La cuenta sigue pausándose si la
// ventana pierde el foco, para no perder un error mientras se mira otra pestaña.
//
// Sin barra de cuenta regresiva (como Material, Sonner, Linear o Stripe): el aviso confirma
// algo y se va solo; la barra solo agregaba urgencia. La librería la sigue animando oculta
// porque es su temporizador: el aviso se cierra al terminar esa animación.

const TYPE_ICONS = {
  success: CircleCheck,
  error: CircleAlert,
  warning: TriangleAlert,
  info: Info,
};

// La librería llama al `icon` del contenedor solo con { type, theme }: no distingue un
// `toast('…')` plano de un `toast.loading('…')`, ambos `default`. Para no perder el spinner
// se renderizan los dos y el CSS muestra uno u otro según la clase `Toastify--animate-icon`,
// que la librería pone en el ícono de todo aviso que NO está cargando.
function renderIcon({ type }) {
  const Icon = TYPE_ICONS[type];
  if (Icon) return <Icon className="bt-toast-glyph" aria-hidden="true" />;
  return (
    <>
      <span className="bt-toast-loading" aria-hidden="true">{Icons.spinner()}</span>
      <Info className="bt-toast-glyph bt-toast-default" aria-hidden="true" />
    </>
  );
}

export function Toaster() {
  const { t } = useTranslation();

  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar
      newestOnTop
      closeOnClick
      pauseOnFocusLoss
      pauseOnHover={false}
      draggable
      theme="light"
      transition={Slide}
      icon={renderIcon}
      closeButton={({ closeToast }) => (
        <button
          type="button"
          className="bt-toast-close"
          aria-label={t('Cerrar')}
          onClick={(event) => {
            // Sin esto el clic también llega al aviso (closeOnClick) y a su onClick propio.
            event.stopPropagation();
            closeToast(event);
          }}
        >
          <X aria-hidden="true" />
        </button>
      )}
    />
  );
}
